import React, { useState, useEffect } from "react";
import { ComparisonChart } from "./ComparisonChart";
import {
  DatePicker,
  InputNumber,
  Button,
  Space,
  Divider,
  Popconfirm,
  Checkbox,
  Select
} from "antd";
import moment from "moment";
import "../../Styles/styles-Compare.css";
import "../../Styles/styles-PostData.css";
import { renderAsPDF } from "../../Utils/pdf_utils";
import { useSelector, useDispatch } from "react-redux";
import {
  emailComparisonData,
  getComparisonData,
  setCompareFilterDates,
  setCompareFilterPlayerGroup,
  setCompareFilterPosition,
  setCompareGameCompare,
  setCompareGameNumber,
  setCompareData
} from "../../store/actions/compare.actions";
import { PositionSelect } from "../PositionSelect/PositionSelect";

const { Option } = Select;

export const DayCompare = ({ activeTab }) => {
  const dispatch = useDispatch();

  const {
    filter: { dates, position, playerGroup },
    gameCompare,
    gameNumber,
    data,
  } = useSelector(({ compare }) => compare);

  const {
    positions,
    playerGroups,
    info: { team_colors: teamColors },
    sport,
  } = useSelector(({ team }) => team);

  const [rendering, setRendering] = useState(false);

  const dateFormat = "YYYY-MM-DD";

  const resetAllValues = () => {
    dispatch(setCompareFilterDates(new Array(5).fill(null)));
    dispatch(setCompareFilterPlayerGroup(undefined));
    dispatch(setCompareFilterPosition(undefined));
    dispatch(setCompareData({metrics: [], data: []}));
  }

  useEffect(() => {
    if(activeTab !== "1") {
      resetAllValues();
    }
  }, [])

  useEffect(() => {
    if(activeTab !== "1") {
      resetAllValues();
    }
  }, [activeTab])

  const getComparison = () => {
    dispatch(getComparisonData());
  };

  const emailComparison = () => {
    dispatch(emailComparisonData());
  };

  const onDateChange = (index, date) => {
    dispatch(
      setCompareFilterDates(
        index,
        date !== null ? date.format(dateFormat) : null
      )
    );
  };

  const onNumGamesChange = (value) => {
    dispatch(setCompareGameNumber(value));
  };

  const onCheckboxChange = (e) => {
    dispatch(setCompareGameCompare(e.target.checked));
  };

  const onPositionChange = (value) => {
    dispatch(setCompareFilterPosition(value));
  };

  const onPlayerGroupChange = (value) => {
    dispatch(setCompareFilterPlayerGroup(value));
  };

  const handleDownloadPDF = async () => {
    setRendering(true);

    let descString = ``;
    if (position) descString = descString + ` | Position: ${position}`;
    if (playerGroup)
      descString = descString + ` | Player Group : ${playerGroup}`;

    await new Promise((r) => setTimeout(r, 300));

    let widget = null,
      table = null;

    const chartDOMs = document.getElementsByClassName("day-compare-chart-and-table");

    await renderAsPDF({header: descString, widget, table, columns: 1, chartDOMs, leftPadding: 0, rightPadding: 0});

    setRendering(false);
  };

  return (
    <>
    <Space>
      <form id="request">
        <Checkbox
          className=""
          checked={gameCompare}
          onChange={onCheckboxChange}
        >
          Compare Games?
        </Checkbox>
        {gameCompare ? (
          <InputNumber
            size="small"
            className="mr-2"
            type="number"
            min="0"
            step="1"
            id="num_games"
            name="num_games"
            value={gameNumber}
            onChange={onNumGamesChange}
          />
        ) : (
          <div className="compare-dates">
            {dates.map((date, index) => (
              <div className="compare-dates-label" key={index}>
                <label htmlFor="date1">Date {index + 1}</label>
                <br />
                <DatePicker
                  value={date !== null ? moment(date, dateFormat) : null}
                  onChange={(date) => onDateChange(index, date)}
                />
              </div>
            ))}
          </div>
        )}
        <PositionSelect
          value={position}
          handleChange={onPositionChange}
          options={positions}
          width={100}
          placeholder="Full Team"
          sport={sport}
        />
        <Select
          allowClear
					optionFilterProp="value"
    			showSearch
          placeholder="All Groups"
          value={playerGroup}
          style={{ width: 100, margin: "0em 1em" }}
          onChange={onPlayerGroupChange}
        >
          {playerGroups.map((playerGroup, i) => {
            return (
              <Option value={playerGroup.name} key={i}>{playerGroup.name}</Option>
            );
          })}
        </Select>
        <Button
          className="mr-2 compare-submit-button"
          type="primary"
          onClick={getComparison}
        >
          Search
        </Button>
        <Popconfirm
          placement="bottom"
          title="Are you sure?"
          onConfirm={emailComparison}
          okText="Yes"
          cancelText="No"
        >
          <Button disabled style={{ width: 100, marginRight: "1em" }}>
            Email
          </Button>
        </Popconfirm>
        <Button
          loading={rendering}
          type="primary"
          onClick={() => {
            handleDownloadPDF();
          }}
        >
          Export as PDF
        </Button>
      </form>
    </Space>
    <div className="data-divider">
      <Divider />
    </div>

    <div className="comparison-chart-compare">
      {data !== null ? (
        <ComparisonChart dataIn={data} teamColors={teamColors} />
      ) : (
        <></>
      )}
    </div>
  </> 
  );
}
